export * from './html-editor-tokenize-pattern-plugin.component';
